import classNames from "classnames";
import React from "react";
import { useRouter } from "next/router";
import { UrlObject } from "node:url";

import styles from "./InfoTitle.module.scss";

interface Props {
  title: string;
  to: UrlObject;
  index: number;
  activeIndex: number;
  setSelectedTab: (index: number) => void;
}

const InfoTitle: React.FC<Props> = ({
  title,
  to,
  setSelectedTab,
  index,
  activeIndex,
}) => {
  const router = useRouter();
  return (
    <li
      className={classNames(styles.infoTitle, {
        [styles.active]: activeIndex === index,
      })}
      onClick={async (event) => {
        event.preventDefault();
        event.stopPropagation();
        setSelectedTab(index);
        if (router.pathname !== to.pathname) {
          router.replace(to);
        }
      }}
      data-href={to}
    >
      <div className="title">{title}</div>
      {activeIndex === index && <div className={styles.line} />}
    </li>
  );
};

export default InfoTitle;
